import React from 'react';
import LandHeader from './LandHeader';
//  import Feature from '../../assets/Images/bg.png';
 import feature from '../../assets/Images/features.png';
 import logo from '../../assets/Images/logo rev.png';
 import bannerVector from '../../assets/Images/bg ( features).png'
import icon1 from '../../assets/Images/Influencers.png';
import icon2 from '../../assets/Images/Buyer.png';
import icon3 from '../../assets/Images/Contact.png';
import icon4 from '../../assets/Images/Wins.png';
import icon5 from '../../assets/Images/Investment.png';
import icon6 from '../../assets/Images/Partnerships.png';
import icon7 from '../../assets/Images/Growth.png';
import icon8 from '../../assets/Images/Strategic.png';
import icon9 from '../../assets/Images/Hiring.png';
import insights from '../../assets/Images/Insights.png';
import Ai from '../../assets/Images/scoop.png';
import Opportunities from '../../assets/Images/Opportunities.png';
import Executive from '../../assets/Images/Executive.png';
import Social from '../../assets/Images/SocialMedia.png';
import intelligence from '../../assets/Images/Intelligence.png';
import Media from '../../assets/Images/Media.png';
import article from '../../assets/Images/Articles.png';
import videos from '../../assets/Images/Videos.png';
import study from '../../assets/Images/Ebooks.png';
import api from '../../assets/Images/API.png';
 import emailicon from '../../assets/Images/EmailTemplates.png';
import curve from '../../assets/Images/Rectangle 3772.png';
import { BiSolidQuoteAltRight } from "react-icons/bi";
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import data from '../../assets/Images/data.png';
// import landing4 from '../../assets/Images/Screenshot .png'
// import { FaAngleRight } from "react-icons/fa";
import './Features.css';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from 'react-router-dom';
import maskphoto2 from '../../assets/Images/Mask group.png'
import { useState, useEffect } from 'react';
import { BiRightArrowAlt } from "react-icons/bi";
import { IoMdClose } from "react-icons/io";
import { IoIosClose } from "react-icons/io";
import { RiArrowDropDownLine } from "react-icons/ri";
import {  Switch } from '@mui/material';
import { styled } from '@mui/material/styles';


function Features() {
const baseURL =
    process.env.NODE_ENV === "production"
      ? process.env.REACT_APP_API_URL_PROD
      : process.env.REACT_APP_API_URL_LOCAL;

    const navigate = useNavigate();
    const [email, setEmail] = useState('');
     const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);
    const [showpopup, setShowPopup] = useState(false);
         const [isExpanded, setIsExpanded] = useState(false);
          const [isOpen, setIsOpen] = useState(false);
           const [isOpen2, setIsOpen2] = useState(false);
           const [showBanner, setShowBanner] = useState(false);
           const [nonNecessaryEnabled, setNonNecessaryEnabled] = useState(true);

    const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
 useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true); // show banner for first-time users
    } else {
      const parsedConsent = JSON.parse(consent);
      setNonNecessaryEnabled(parsedConsent.nonNecessaryEnabled);
      if (!parsedConsent.nonNecessaryEnabled) {
        setShowBanner(true); // show banner if user disabled cookies
      } else {
        setShowBanner(false);
      }
    }
  }, []);
  
  const handleAccept = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({ nonNecessaryEnabled: true })
    );
    setNonNecessaryEnabled(true);
    setShowBanner(false);
  };
  
  const handleSaveExit = () => {
    localStorage.setItem(
      "cookieConsent",
      JSON.stringify({ nonNecessaryEnabled })
    );
  
    if (nonNecessaryEnabled) {
      setShowBanner(false); // hide if enabled
    } else {
      setShowBanner(true); // show if disabled
    }
    setShowPopup(false);
  };
   const content = `This website uses cookies to improve your experience while
   you navigate through the website. Out of these cookies, the cookies that are categorized as necessary 
   are stored on your browser as they are as essential for the working of basic functionalities of the 
   website. We also use third-party cookies that help us analyze and understand how you use this website.
    These cookies will be stored in your browser only with your consent. You also have the option to
     opt-out of these cookies. But opting out of some of these cookies may have an effect on your browsing
      experience.`;

      const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  const toggleContent = () => {
    setIsOpen2(false);
    setIsOpen(!isOpen);
    
  }

  const toggleContent2 = () => {
    setIsOpen(false)
    setIsOpen2(!isOpen2)
    
  }

  const handleClose = () => {
    setShowPopup(false);
  }

  const CustomSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(
    ({ theme }) => ({
      width: 60,
      height: 25,
      padding: 0,
      display: 'flex',
      marginLeft:10,
      '& .MuiSwitch-switchBase': {
        padding: 4,
        '&.Mui-checked': {
          transform: 'translateX(26px)',
          color: '#009F0B',
          '& + .MuiSwitch-track': {
            backgroundColor: '#009F0B',
            '&:before': {
              left: 8,
            },
          },
        },
      },
      '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 0 0 / 20%)',
        width: 19,
        height: 19,
        borderRadius: '50%',
        backgroundColor: '#D9D9D9',
        marginLeft:5,
      },
      '& .MuiSwitch-track': {
        position: 'relative',
        borderRadius: 34 / 2,
        backgroundColor: 'grey',
        transition: theme.transitions.create(['background-color'], {
          duration: 500,
        }),
        '&:before': {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          left: 34,
          color: 'white',
          fontSize: 12,
          fontWeight: 600,
        },
      },
    })
  );

  const cookiePopup = () => {
    setShowPopup(true);
  }

      const handlePricingClick = async () => {
          if (!email) {
            alert("Please enter a valid email address");
            return;
          }
      
          try {
            await axios.post(`${baseURL}/api/send-mail`, { email });
            Swal.fire({
            icon: "success",
            title: "Success",
            text: "Email sent successfully!",
          });
          } catch (error) {
            console.error("Error sending email:", error);
            Swal.fire({
            icon: "error",
            title: "Oops!",
            text: "Failed to send email. Please try again later.",
          });
          }
        };

        useEffect(() => {
            const script = document.createElement("script");
            script.src = "//code.tidio.co/jvv1c4iihhivgeguhxf9htan43mttvv5.js";
            script.async = true;
            document.body.appendChild(script);
          }, []);
        
          const openChat = () => {
            if (window.tidioChatApi) {
              window.tidioChatApi.open();
            } else {
              console.warn("Tidio API not ready yet.");
            }
          };

  return (
    <>
     <div>
           <img src={bannerVector} alt="vector background" className='banner-vector3' />
        </div>
        <div>
     <div className="header">
       <div className="container">
         <div className="header-logo">
           <img
             src={logo}
             alt="octonius-logo"
             onClick={() => navigate("/")}
             style={{ cursor: "pointer" }}
           />
         </div>
     
         {/* Hamburger button */}
         <button className="hamburger" onClick={toggleMenu}>☰</button>
     
         {/* Nav Menu */}
         <div className={`nav-menu ${menuOpen ? "open" : ""}`}>
           {/* Close button inside nav */}
           <button className="close-btn" onClick={toggleMenu}><IoMdClose /></button>
     
           <nav className={`menu ${location.pathname === "/" ? "active" : ""}`} onClick={() => navigate("/")}>
             Home
           </nav>
           <nav className={`menu ${location.pathname === "/features" ? "active" : ""}`} onClick={() => navigate("/features")}>
             Features
           </nav>
           <nav className={`menu ${location.pathname === "/pricing" ? "active" : ""}`} onClick={() => navigate("/pricing")}>
             Pricing
           </nav>
           <nav className={`menu ${location.pathname === "/contact" ? "active" : ""}`} onClick={() => navigate("/contact")}>
             Contact
           </nav>
     
           <div className="free-login">
            <nav className="menu" onClick={() => window.open("https://app.revenuintel.com", "_blank")}>
  Login
</nav>
             <button className="log-btn" onClick={() => navigate('/free-trial')}>
               Free Trial <span className="btn-icon"><BiRightArrowAlt /></span>
             </button>
           </div>
         </div>
       </div>
     </div>
       </div>
       <div className='landing-page'>
       
       <div className='banner-content'>
            <div className='land-title'>
                <div className='land-title1'>Features that Help </div>
                <div className='land-title2'>You To know your </div>
                 <div className='land-title2'>Buyer Inside Out </div>
                <div className='land-title4' style={{fontWeight:"400", fontSize:"15px"}}> Get deep insights into buyer intent, behavior, and firmographics so you can engage with precision and confidence </div>
              
            </div>
         
            
          
            
            </div>
    <div className='feature-land'>
   
    <div className='feature-para1' >
    No matter what level of buyer journey your prospect is in, you'll know exactly 
     what you need to say to make the sale (or purchase). And if you're not sure 
   what your ideal prospect looks like or where they are in the process, or even 
    how they discovered your offer, revenuintel will help you uncover all of 
     these nitty-gritty details.
    </div>
    <div className='btns2'>
    <button className='feature-price-btn' onClick={openChat}>Talk to us  <span className="btn-icon"><BiRightArrowAlt /> </span></button>
    <button className='feature-demo-btn' onClick={() => {navigate("/free-trial"); window.scrollTo(0, 0); }}>Free Trial <span className="btn-icon"><BiRightArrowAlt /> </span></button>
    </div>
    </div>
    <div className='feature-land2'>
       <div className='feature-head2'>
       Know Your Buyer
       </div>
       <div className='feature-para2'>
       ABM campaigns start with knowing your buyer intimately. revenuintel allows you to build out detailed 
       buyer personas, identify the influencers in the target organization, and get their contact info.
       </div>
       <div className='feature-containers'>
         <div className='fea-container'>
          <div className='fea-img'>
             <img src={icon1} alt="icon" width="50px" height="50px" />
             <div className='img-text'> Influencers </div>
          </div>
          <div className='container-para'>
          Identify the key decision-makers and other 
          <br />significant influencers in senior leadership, <br />
           mid-level management, individual <br />
            contributors and other key people. 
             Also, <br /> discover market thought leaders in your <br />
              target organization.
          </div>
          </div>    
          <div className='fea-container'>
          <div className='fea-img'>
             <img src={icon2} alt="icon" width="50px" height="50px" />
             <div className='img-text'> Buyer Persona </div>
          </div>
          <div className='container-para'>
          revenuintel allows you to build out
          <br />detailed buyer personas, identify the<br />
          challenges and pain points of your ideal <br />
          prospect, their intent and find the right way<br /> to speak with them. 
          </div>
          </div>    
          <div className='fea-container'>
          <div className='fea-img'>
             <img src={icon3} alt="icon" width="50px" height="50px" />
             <div className='img-text'> Contact Info </div>
          </div>
          <div className='container-para'>
          You'll also know the right way to reach out
          <br />to your prospects by getting their contact <br />
          information like email address, phone <br />
          number and social media co-ordinates.
          </div>
          </div>    
       </div>
    </div>
    <div className='feature-land3'>
       <div className='feature-head3'>
       Explore Key Accomplishments
       </div>
       <div className='feature-para3'>
       Understanding the key accomplishments of your target organization helps you frame the message that points
        to its future potential. revenuintel doesn't just help you achieve the 
       sale but also enables you to raise the bar of your enterprise marketing team.
       </div>
       <div className='feature-container2'>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={icon4} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Recent Wins</div>
            </div>
            <div className='container-para2'>
            revenuintel will help you see which recent business wins your <br />
             target organization has achieved and how the win was accomplished. <br />
              Frame the presentation of your next campaign smartly.
            </div>
        </div>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={icon5} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Investment and Acquisitions</div>
            </div>
            <div className='container-para2'>
            revenuintel will help you identify recent acquisitions, investments <br />
            and stakeholdings in your target organization. This helps to <br />
            understand your target organisation’s level of interest in growing its <br />
            market presence vis-a-vis your offering.
            </div>
        </div>
       </div>
       <div className='feature-container2'>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={icon6} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Partnerships</div>
            </div>
            <div className='container-para2'>
            revenuintel helps you recognize key partners, including partners <br />
            in government, investors, advisors and influencers. Knowing what <br />
            those partners bring to the table will help you better position your <br />
            own offering.
            </div>
        </div>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={icon7} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Growth</div>
            </div>
            <div className='container-para2'>
            revenuintel will help you understand the growth of your target<br />
            organization, its demographics and recent investments in technology.<br />
            Without this information, you risk being unprepared for a long sales <br />
            cycle or a brand new requirement.
            </div>
        </div>
       </div>
    </div>
    <div className='feature-land4'>
     <div className='feature-head4'>
     Know What They’re Up to
     </div>
     <div className='feature-para4'>
     By understanding the strategic initiatives and hiring activities, you are well-positioned to understand the 
     future  of the target organization. Savvy ABM marketers take this information and use it to understand their target
     market's perspective.
     </div>
     <div className='feature-container2'>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={icon8} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Strategic Initiatives</div>
            </div>
            <div className='container-para2'>
            revenuintel will help you identify the strategic initiatives being <br />
            undertaken by your target organization. t Scoop will give you<br />
            insights into how your target organizations are competing with others <br />
            in the market, and also how it plans to continue to grow.
            </div>
        </div>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={icon9} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Hiring Activities</div>
            </div>
            <div className='container-para2'>
            revenuintel will help you identify the types of people that your<br />
            target organization is looking to hire and understand its expectations<br />
            from candidates. This gives you a deeper understanding of your <br />
            target market, allowing you to frame your message better.
            </div>
        </div>
       </div>
    </div>
    <div className='feature-land5'>
      <div className='feature-head5'>
      Glean Deeper Insights
      </div>
      <div className='feature-para5'>
      revenuintel will help you uncover key executive insights, scoops, opportunities and more. Using these 
       data, you'll be better equipped to develop messaging that resonates with your target market and create
       business wins – in the fastest way possible.
      </div>
      <div className='feature-container3'>
      <div className='fea-container3'>
       <div className='fea-img'>
         <div className='image'>
          <img src={insights} alt="insights" width="70px" height="70px" />
         </div>
       </div>
       <div className='container-head'>
       Executive Insights & <br /> Talking Points
       </div>
       <div className='container-para3'>
       revenuintel will offer you a detailed 
       collection of quotes from your target 
        organization's executives and insights 
         into their thoughts on various subjects. 
          Now, it's easy to reach your target market
           with a level of intelligence and 
           authenticity.
       </div>
      </div>
      <div className='fea-container3'>
       <div className='fea-img'>
         <div className='image'>
          <img src={Ai} alt="insights" width="70px" height="70px" />
         </div>
       </div>
       <div className='container-head'>
      Scoops
       </div>
       <div className='container-para3'>
       revenuintel helps you uncover your<br />
       target's recent wins and other inside <br />
       scoops that can be useful in positioning <br />
       your offering. This includes competitor <br />
       wins and failures as well as customer <br />
       wins and losses.
       </div>
      </div>
      <div className='fea-container3'>
       <div className='fea-img'>
         <div className='image'>
          <img src={Opportunities} alt="insights" width="70px" height="70px" />
         </div>
       </div>
       <div className='container-head'>
       Opportunities
       </div>
       <div className='container-para3'>
       revenuintel will help you uncover the <br />
       opportunities that your target market is <br />
       looking for. With this information, you <br />
       won't be left in the dark when <br />
       understanding their business <br />
       environment.
       </div>
      </div>
      </div>
      <div className='feature-container3'>
      <div className='fea-container4'>
       <div className='fea-img'>
         <div className='image'>
          <img src={Executive} alt="insights" width="70px" height="70px" />
         </div>
       </div>
       <div className='container-head'>
       Executive Moves 
       </div>
       <div className='container-para3'>
       revenuintel will help you track the <br />
       recent executive moves and other <br />
       personnel changes in your target market. <br />
       Having this data at your fingertips will <br />
       help you understand the future direction <br />
       of your target market.
       </div>
      </div>
      <div className='fea-container4'>
       <div className='fea-img'>
         <div className='image'>
          <img src={Social} alt="insights" width="70px" height="70px" />
         </div>
       </div>
       <div className='container-head'>
       Social Media Listening
       </div>
       <div className='container-para3'>
       Most executives are personally active on<br />
       at least one social media platform. <br />
       revenuintel allows you to get access <br />
       to their unfiltered views on topics that <br />
       matter to you.
       </div>
      </div>
      <div className='fea-container4'>
       <div className='fea-img'>
         <div className='image'>
          <img src={intelligence} alt="insights" width="70px" height="70px" />
         </div>
       </div>
       <div className='container-head'>
       Competitor Intelligence
       </div>
       <div className='container-para3'>
       revenuintel helps to extract <br />
       competitor intelligence on how they <br />
       operate, by providing insights into several <br />
       aspects of their business like strengths, <br />
       failures, weaknesses and threats.
       </div>
      </div>
      </div>
    </div>
    <div className='feature-land6'>
     <div className='feature-head6'>
     Explore Thought Leadership
     </div>
     <div className='feature-para6'>
     By profiling your target organization’s take on various aspects of their business through the content they
      publish, you can understand what matters to them and use it to your advantage.
     </div>
     <div className='feature-container2'>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={Media} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Media Releases</div>
            </div>
            <div className='container-para2'>
            revenuintel helps you get access to the press releases and other <br />
            announcements from your target organization. You will have another <br />
            opportunity to frame your message based on things that are <br />
            meaningful to your target market.
            </div>
        </div>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={article} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Articles</div>
            </div>
            <div className='container-para2'>
            Articles such as software reviews, Analyst reports related to their <br />
            company in various sources such as e-magazine and journals will <br />
            give you an insight into how outsiders see your target organization.
            </div>
        </div>
       </div>
       <div className='feature-container2'>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={study} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Case Studies, Ebooks and White Papers</div>
            </div>
            <div className='container-para2'>
            revenuintel will help you access case studies, white papers and <br />
            ebooks published by your target organization. As a result, you'll be <br />
            better equipped to talk intelligently with your target market about their <br />
            business needs.
            </div>
        </div>
        <div className='fea-container2'>
            <div className='fea-img'>
              <img src={videos} alt="wins" width="50px" height="50px" />
              <div className='img-text'>Videos</div>
            </div>
            <div className='container-para2'>
            revenuintel will help you access videos of people talking about <br />
            your target organization or third party content communities they are <br />
            part of.
            </div>
        </div>
       </div>
    </div>
    <div className='feature-land7'>
      <div className='feature-head7'>
      Enjoy Robust Workflows
      </div>
      <div className='feature-para6'>
      revenuintel offers time-saving workflows for your ABM efforts. Use these workflows to create a
       straightforward process for engaging with your target market.
      </div>
      <div className='feature-containers'>
         <div className='fea-container'>
          <div className='fea-img'>
             <img src={api} alt="icon" width="50px" height="50px" />
             <div className='img-text'> API Integration </div>
          </div>
          <div className='container-para'>
          Experience the ultimate extendability of
          <br />revenuintel's features by integrating <br />
          them with your platform. With that, you can <br />
          create customized insights and reports
              <br /> that will enable your unique business <br />
              demands.
          </div>
          </div>    
          <div className='fea-container'>
          <div className='fea-img'>
             <img src={emailicon} alt="icon" width="50px" height="50px" />
             <div className='img-text'> Email Templates </div>
          </div>
          <div className='container-para'>
          Accelerate your campaigns using
          <br />customizable email templates: leverage<br />
          revenuintel's insights and actionable <br />
          information to create the most effective<br /> email campaigns possible.
          </div>
          </div>    
          <div className='fea-container'>
          <div className='fea-img'>
             <img src={data} alt="icon" width="50px" height="50px" />
             <div className='img-text'> Data Enrichment</div>
          </div>
          <div className='container-para'>
          revenuintel helps you gain access to
          <br />your target organization's data. This will <br />
          allow you to enrich your data with more <br />
          relevant information to your business <br />needs.
          </div>
          </div>    
       </div>
    </div>
      <div className='lead-generating'>
                    <span className="lead-text">Start generating B2B leads today!</span>
                      <button className='demo-btn-talk' onClick={() => {navigate("/pricing"); window.scrollTo(0, 0); }}>Pricing  <span className="btn-icon"><BiRightArrowAlt /> </span></button>
                   </div>
                  
                   <div className='landing-6'>
                    <BiSolidQuoteAltLeft style={{marginLeft:"21%",marginTop:"40px"}} />
                   <div className='content-9'>
                 Accurate key Insights provided on a timely basis. This really helps for our 
                    Sales process to get started &nbsp; <BiSolidQuoteAltRight style={{fontSize:"15px"}}/>  </div> 
                  
                    <div style={{ marginTop:"10px", color:"black", fontWeight:"700", textAlign:"center", fontSize:"12px"}} >
                     <img src={maskphoto2} alt="maskphoto"  width="50px"/> <br />Erhan Eren <div style={{fontWeight:"500"}}>Founder and CEO, Enkiai.com</div></div>  
                  
     
                   </div>
               <div className="curved-footer-wrapper">
       <div className="footer-image-container">
         <img src={curve} alt="curve" className="footer-curve-img" />
         <div className="landing-7">
           <div className="land-contents-10">
             We’d love to hear from you <br />
             <span className="land-content-11" style={{marginTop:"20px"}}>support@revenuintel.com</span><br />
            
           </div>
           <div className="land-contents-11">
             Get Revenuintel Today <br />
             <div style={{ position: "relative", display: "flex", alignItems: "center", marginTop: "40px" }}>
       <input type="email" placeholder='Business mail' className='mail-input' value={email}
        onChange={(e) => setEmail(e.target.value)} />
       <button className="mail-price-btn" onClick={handlePricingClick}>Pricing</button>
     </div>
     
             
           </div>
           <div className="land-contents-13" style={{fontWeight:"500"}}>
             Powered by, <br />
             Merkat Intellekt Technologies <br />
             <span className="land-content-15">Private Limited</span>
           </div>
         </div>
       </div>
     </div>
                
    </div>
      {showBanner && (
                                    <div className='cookies'>
                                       <div className='cookie-text'>This website uses cookies to improve your experience. We'll assume you're ok with this, but you can opt-out if you wish</div>
                                    <div className='cookie' style={{cursor:"pointer"}} onClick={cookiePopup}>Cookie Settings</div>
                                    <div> <button className="cookie-btn" onClick={handleAccept}>Accept</button></div>
                                    </div> )}
                              {showpopup && (
               <div className="overlay">
                 <div className="privacy-popup">
                   <div className="privacy-overview">
                     <div className="popup-header">Privacy Overview</div>
                     <div className='privacy-close' onClick={handleClose}><IoIosClose /></div>
                   </div>
                  <div className="privacy-content">
                   {isExpanded ? content : `${content.substring(0, 200)}...`}
                   <span
                     className="privacy-content-span"
                     onClick={toggleReadMore}
                     style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
                   >
                     {isExpanded ? " See Less" : " See More"}
                   </span>
                 </div>
                <div className="privacy-neccessary">
                   <div className="neccessary-head" >
                     <div className="neccessary-text" onClick={toggleContent}>
                       <RiArrowDropDownLine
                         style={{
                           fontSize: "35px",
                           transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                           transition: "transform 0.3s ease"
                         }}
                       />{" "}
                       Necessary
                     </div>
                     <div className="neccessary-text">Always Enabled</div>
                   </div>
             
                   {isOpen && (
                     <div className="neccessary-content">
                       Necessary cookies are absolutely essential for the website to
                       function properly. This category only includes cookies that ensure
                       basic functionalities and security features of the website. These
                       cookies do not store any personal information.
                     </div>
                   )}
                 </div>
                  <div className="privacy-neccessary">
                   <div className="neccessary-head" >
                     <div className="neccessary-text" onClick={toggleContent2}>
                       <RiArrowDropDownLine
                         style={{
                           fontSize: "35px",
                           transform: isOpen2 ? "rotate(180deg)" : "rotate(0deg)",
                           transition: "transform 0.3s ease"
                         }}
                       />{" "}
                      Non-Necessary
                     </div>
                     <div> <CustomSwitch checked={nonNecessaryEnabled}
                           onChange={(e) => setNonNecessaryEnabled(e.target.checked)} /></div>
                   </div>
             
                   {isOpen2 && (
                     <div className="neccessary-content">
                      Any cookies that may not be particularly necessary for the website to function
                       and is used specifically to collect user personal data via analytics, ads, other embedded 
                       contents are termed as non-necessary cookies. It is mandatory to procure user consent prior
                        to running these cookies on your website.
                     </div>
                   )}
                 </div>
                 <div className='privacy-save'>
                   <button className='privacy-save-btn' onClick={handleSaveExit}>Save & Exit</button>
                 </div>
                 </div>
               </div>
             )}
    </>
  )
}

export default Features